import { isEmpty } from 'lodash';
import { v4 as uuidv4 } from 'uuid';

export function deleteInAvalaibleSchedules({ subscription, schedule }) {
    let schedules = this.availableSchedules[subscription.id] || [];
    this.availableSchedules[subscription.id] = schedules.filter(
        (item) => item.scheduleId !== schedule.scheduleId
    );
    this.observed.availableSchedules = uuidv4();
}
